import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { DarkModeService } from '../../services/dark-mode.service';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  private iconsCache: Map<string, string> = new Map();

  constructor(
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer,
    private darkModeService: DarkModeService
  ) {}

  loadIcon(iconName: string, width: string = '100%', height: string = '100%'): Observable<SafeHtml | null> {
    const isDarkMode = this.darkModeService.isDarkMode();
    const cacheKey = `${iconName}_${isDarkMode}`;

    if (this.iconsCache.has(cacheKey)) {
      const cachedSvg = this.iconsCache.get(cacheKey)!;
      const svgWithSize = cachedSvg.replace('<svg', `<svg style="width: ${width}; height: ${height};"`);
      return of(this.sanitizer.bypassSecurityTrustHtml(svgWithSize));
    }

    return this.httpClient.get(`assets/svg/${iconName}.svg`, { responseType: 'text' }).pipe(
      map((svgContent) => {
        // Modyfikuj kolor w zależności od dark mode
        let modifiedSvg = svgContent;
        if (isDarkMode) {
          // Zamień wszystkie atrybuty stroke na biały kolor
          modifiedSvg = modifiedSvg.replace(/stroke="#[0-9a-fA-F]{6}"/g, 'stroke="#ffffff"');
          modifiedSvg = modifiedSvg.replace(/stroke="#[0-9a-fA-F]{3}"/g, 'stroke="#ffffff"');
          // Obsługa innych formatów kolorów dla stroke
          modifiedSvg = modifiedSvg.replace(/stroke="[^"]*"/g, 'stroke="#ffffff"');

          // Zamień wszystkie atrybuty fill na biały kolor (z wyjątkiem fill="none")
          modifiedSvg = modifiedSvg.replace(/fill="#[0-9a-fA-F]{6}"/g, 'fill="#ffffff"');
          modifiedSvg = modifiedSvg.replace(/fill="#[0-9a-fA-F]{3}"/g, 'fill="#ffffff"');
          // Obsługa innych formatów kolorów dla fill (ale pomijamy "none")
          modifiedSvg = modifiedSvg.replace(/fill="(?!none)[^"]*"/g, 'fill="#ffffff"');
        }

        // Cache modified SVG
        this.iconsCache.set(cacheKey, modifiedSvg);

        const svgWithSize = modifiedSvg.replace('<svg', `<svg style="width: ${width}; height: ${height};"`);
        return this.sanitizer.bypassSecurityTrustHtml(svgWithSize);
      }),
      catchError((error) => {
        console.error(`Error loading icon: ${iconName}`, error);
        return of(null);
      }),
      shareReplay(1)
    );
  }
}
